import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  EditOutlineIcon,
  TrashOutlineIcon,
  ThreeDotsHorizontal,
  UnarchiveIcon
} from '../../../icons';
import DropdownSystem from '../../DesignSystem/DropdownSystem';
import * as projectActions from '../../../redux/slices/projectSlice';
import useConfigurationPermissions from '../../../hooks/useConfigurationPermissions';
import { getCurrentCompany } from '../../../utils/userUtils';
import { trackingEvent } from '../../../analytics';
import { Colors } from '../../../constants/colors.constants';

const ActionsMenu = ({
  project,
  t,
  setFormProjectVisible,
  setFormDeleteVisible,
  setShowUnarchiveModal
}) => {
  const dispatch = useDispatch();
  const projectState = useSelector((state) => state.projectState);
  const permissions = useConfigurationPermissions();
  const [isHovered, setIsHovered] = useState(false);

  const handleEditMenuClick = () => {
    setFormProjectVisible(true);
    dispatch(
      projectActions.setProps({
        ...projectState.props,
        currentProjectId: project.id,
        openFormProject: true
      })
    );
  };

  const handleDeleteMenuClick = () => {
    setFormDeleteVisible(true);
    dispatch(
      projectActions.setProps({
        ...projectState.props,
        modalDeleteVisible: true,
        currentProject: project
      })
    );
  };

  const handleUnarchiveMenuClick = () => {
    setShowUnarchiveModal(true);
    dispatch(
      projectActions.setProps({
        ...projectState.props,
        currentProject: project
      })
    );

    const company = getCurrentCompany();
    trackingEvent('project_unarchive_initiated', {
      organization_name: company.name,
      organization_id: company.id,
      project_name: project.name,
      project_id: project.id
    });
  };

  if (permissions.project !== 'AC') {
    return null;
  }

  return (
    <div
      className="unarchive-actions-menu"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}>
      {DropdownSystem({
        theme: 'light',
        trigger: ['click'],
        items: [
          {
            key: 'edit',
            label: t('edit_label'),
            icon: <EditOutlineIcon color={Colors.DARK_MINT} />,
            onClick: handleEditMenuClick,
            subitems: []
          },
          ...(project.stage === 'archived'
            ? [
                {
                  key: 'unarchive',
                  label: t('unarchive_label'),
                  icon: <UnarchiveIcon color={Colors.DARK_MINT} />,
                  onClick: handleUnarchiveMenuClick,
                  subitems: []
                }
              ]
            : []),
          {
            key: 'delete',
            label: t('delete_lable'),
            icon: <TrashOutlineIcon color={Colors.DARK_MINT} />,
            onClick: handleDeleteMenuClick,
            subitems: []
          }
        ],
        icon: (
          <ThreeDotsHorizontal
            color={isHovered ? Colors.DARK_MINT : Colors.WHITE}
          />
        )
      })}
    </div>
  );
};

ActionsMenu.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    stage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  t: PropTypes.func.isRequired,
  setFormProjectVisible: PropTypes.func.isRequired,
  setFormDeleteVisible: PropTypes.func.isRequired,
  setShowUnarchiveModal: PropTypes.func.isRequired
};

export default withTranslation()(ActionsMenu);
